<div
  id="image"
  [ngClass]="
    expand() ? 'w-full h-[20rem] rounded-xl' : 'size-48 min-w-48 rounded-full'
  "
  class="overflow-hidden border border-zinc-100"
>
  <img [src]="src()" class="object-cover w-full h-full" />
</div>
